<template>
    <div>
        <Sidebar></Sidebar>

        <!-- Modals -->
        <ConfirmationModal
            v-if="modal.isShowModal && legalInformation"
            :showModal.sync="modal.isShowModal"
            :question="modalQuestion"
            :closeButtonText="'Annuler'"
            :confirmButtonText="'Rendre opposable'"
            :isParseHtml="true"
            :isSwapButtons="true"
            @confirmApprove="makeEffective"
        ></ConfirmationModal>
        <!-- Modals -->

        <div class="content-wrapper content-wrapper-exemption">
            <div class="img-desktop img-desktop-create d-lg-inline-block"></div>

            <Header v-show="!isShowSpinner"></Header>

            <section v-if="isShowSpinner" class="content mt-5">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-10 form-request-content-large">
                  <div class="text-center">
                    <PageSpinner
                        :isLoading="isShowSpinner"
                    ></PageSpinner>
                  </div>


                  <h3
                      v-if="xlsxEmailsFormData.isSubmitting"
                      class="mt-5"
                  >
                    L'envoi des notifications est en cours. Veuillez patienter. Ne quittez pas cette page.
                  </h3>
                </div>
              </div>
            </div>
          </section>

          <div v-show="!isShowSpinner" class="content">
            <div class="request-title">
              <h1>Notifier la DUE </h1>
            </div>
            <div>
              <p
                  v-if="legalInformation"
                  v-html="dueMakeEffectivePageDescriptionLegalAdviceText"
              ></p>
            </div>
            <div v-if="legalInformation" class="page-description">
              <p>{{ legalInformation.dueMakeEffectivePageContentListTitleLegalAdviceText.legalAdvice }}</p>
              <p v-html="dueMakeEffectivePageContentListItemsLegalAdviceText"></p>
            </div>
          </div>

          <div class="content custom-tabs__wrapper">
            <div v-show="!isShowSpinner" class="content">
              <ul class="nav nav-tabs nav-fill">
                <li class="nav-item">
                <span
                    class="nav-link tab-link"
                    @click="isActive = 1" v-bind:class="{ active: !isActive || isActive == 1 }"
                >
                  Notification individuelle par email à un salarié
                </span>
                </li>
                <li class="nav-item">
                <span
                    class="nav-link tab-link"
                    @click="isActive = 2" :class="{ active: isActive == 2 }"
                >
                  Notification groupée à plusieurs salariés
                </span>
                </li>
                <li class="nav-item">
                <span
                    class="nav-link tab-link"
                    @click="isActive = 3" :class="{ active: isActive == 3 }"
                >
                  Télécharger un document justificatif
                </span>
                </li>
              </ul>
            </div>

            <div class="content tab-content">

              <!-- single email -->
              <section
                  v-show="!isShowSpinner"
                  class="content tab-item"
                  v-bind:class="{ active: !isActive || isActive == 1 }"
              >
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-md-10 form-request-content-large">

                      <div class="form-group">
                        <form
                            name="exemption"
                            method="post"
                            enctype="multipart/form-data"
                            novalidate="novalidate"
                            class="needs-validation"
                        >
                          <label for="email" >Notifier à un utilisateur</label>
                          <div class="row">
                            <div class="col-md-5">
                              <!-- Email -->
                              <input
                                  v-model="singleEmailFormData.email"
                                  @input="delayTouch($v.singleEmailFormData.email)"
                                  :class="{ 'is-invalid': $v.singleEmailFormData.email.$error }"
                                  type="email"
                                  id="email"
                                  class="form-control form-control-lg"
                                  placeholder="exemple@entreprise.com"
                              >
                              <FormError
                                  v-if="!$v.singleEmailFormData.email.email && $v.singleEmailFormData.email.$dirty"
                                  error="Format de l'email incorrect"
                              ></FormError>
                              <!-- Email -->
                            </div>
                            <div class="col-md-7">
                              <div class="mx-sm-auto">
                                <button
                                    @click.prevent="sendSingleEmail()"
                                    :disabled="$v.singleEmailFormData.email.$invalid || singleEmailFormData.isSubmitting"
                                    class="btn btn-success btn__save due-email__btn"
                                >
                                  <span>Notifier DUE par email</span>
                                  <ButtonSpinner :isLoading="singleEmailFormData.isSubmitting"></ButtonSpinner>
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </section>


              <!-- upload xlsx emails -->
              <section
                  v-show="!isShowSpinner"
                  class="content tab-item"
                  v-bind:class="{ active: isActive == 2 }"
              >
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-md-10 form-request-content-large">
                      <div class="form-group">
                        <form
                            name="exemption"
                            method="post"
                            enctype="multipart/form-data"
                            novalidate="novalidate"
                            class="needs-validation"
                        >
                          <div>
                            <!-- Email -->
                            <label for="emails">Notification multiple : télécharger un fichier</label>
                            <div class="row">
                              <div class="col-md-5 upload-recipient__wrapper">
                              <span class="btn btn-file btn-outline-primary">
                                <span v-if="!xlsxEmailsFormData.file">Télécharger un fichier avec la liste de destinataires</span>
                                <span v-else>Remplacer ce fichier</span>
                                <input
                                    @change="handleXlsxFileUpload($event)"
                                    type="file"
                                    id="emails"
                                >
                              </span>
                                <span
                                    v-if="xlsxEmailsFormData.file"
                                    class="ml-2"
                                >
                                {{ xlsxEmailsFormData.file.name }}
                              </span>
                                <a
                                    v-if="xlsxEmailsFormData.file"
                                    @click.prevent="deleteXlsxFile()"
                                    href
                                    class="close ml-2"
                                >×</a>
                                <FormError
                                    v-if="!$v.xlsxEmailsFormData.file.validMimeType && !$v.xlsxEmailsFormData.file.$dirty"
                                    error="Les formats des fichiers autorisés sont .xlsx"
                                ></FormError>
                                <p
                                    v-if="legalInformation"
                                    class="input-legend"
                                >
                                  {{ legalInformation.employeeEmailMultipleNotificationLegalAdviceText.legalAdvice }}
                                </p>
                              </div>
                              <div class="col-md-6">
                                <button class="btn btn-success btn__save"
                                        :disabled="$v.xlsxEmailsFormData.$invalid || !xlsxEmailsFormData.isEnabled"
                                        @click.prevent="sendXlsxEmails()"
                                >
                                  <span>Notifier DUE par email</span>
                                  <ButtonSpinner :isLoading="xlsxEmailsFormData.isSubmitting"></ButtonSpinner>
                                </button>
                              </div>
                            </div>

                            <div class="mx-sm-auto mt-4">
                              <button
                                  @click.prevent="generateTemplate()"
                                  class="btn btn-link_download"
                              >
                                  Télécharger le fichier d'exemple
                              </button>
                            </div>
                          </div>

                        </form>
                      </div>
                    </div>

                  </div>
                </div>
              </section>

              <!-- dueSignOffSheetDocumentFormData -->
              <section
                  v-show="!isShowSpinner"
                  class="content tab-item"
                  v-bind:class="{ active: isActive == 3 }"
              >
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-md-10 form-request-content-large">
                      <div class="mt-4 supporting-docs__inner">
                        <label for="due-sign-off-sheet-document">Complément de notification si nécessaire</label>
                        <div>
                        <span class="btn btn-file btn-outline-primary">
                          <span v-if="!dueSignOffSheetDocumentFormData.file">Télécharger un fichier</span>
                          <span v-else>Remplacer ce fichier</span>
                          <input
                              @change="uploadDueSignOffSheetDocument($event)"
                              type="file"
                              id="due-sign-off-sheet-document"
                          >
                        </span>
                          <a
                              v-if="dueSignOffSheetDocumentFormData.file"
                              @click.prevent="downloadDocument()"
                              href
                              download
                              class="ml-2"
                          >{{ dueSignOffSheetDocumentFormData.file.name }}</a>
                          <a
                              v-if="dueSignOffSheetDocumentFormData.file"
                              @click.prevent="deleteDocument()"
                              href
                              class="close ml-2"
                          >×</a>
                          <FormError v-if="!$v.dueSignOffSheetDocumentFormData.file.validFileSize
                                                                 && !$v.dueSignOffSheetDocumentFormData.file.$dirty"
                                     error="La taille du fichier ne doit pas dépasser 4MO"
                          ></FormError>
                          <FormError v-if="!$v.dueSignOffSheetDocumentFormData.file.validMimeType
                                                                 && !$v.dueSignOffSheetDocumentFormData.file.$dirty"
                                     error="Les formats des fichiers autorisés sont .jpeg .jpg .pdf"
                          ></FormError>
                          <p
                              v-if="legalInformation"
                              class="input-legend"
                          >{{ legalInformation.dueSignOffSheetDocumentLegalAdviceText.legalAdvice }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <!-- dueSignOffSheetDocumentFormData -->
            </div>

          </div>

            <!-- make effective -->
            <section
                v-if="isNotEffective"
                v-show="!isShowSpinner"
                class="content"
            >
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-12  form-request-content-large text-center">
                            <label>J'ai accompli les formalité d'opposabilité</label>
                            <div class="mx-sm-auto">
                                <button
                                    @click="handleOpenPopup()"
                                    class="btn btn-lg  btn__primary"
                                >
                                    <span>Rendre opposable</span>
                                    <ButtonSpinner :isLoading="makeEffectiveFormData.isSubmitting"></ButtonSpinner>
                                </button>
                            </div>
                            <FormError
                                v-if="!makeEffectiveFormData.isEnabled"
                                error="Vous avez téléversé un fichier avec une liste des adresses email,
                                    mais vous n'avez pas cliqué sur le bouton 'Envoyer les emails'.
                                    Vous este sur le point de rende opposable la DUE sans notifier les salariés."

                            ></FormError>
                        </div>
                    </div>
                </div>
            </section>

            <!-- employee emails -->
            <section
              v-show="!isShowSpinner"
              class="content table-content"
            >
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-10 form-request-content-large">
                            <div class="request-title list-title mt-4">
                                <h1>DUE notifiée à
                                    <span v-if="pagination.totalItems">{{ pagination.totalItems }} personnes</span>
                                </h1>
                            </div>

                            <vuetable ref="vuetable"
                                      :fields="fields"
                                      :api-mode="false"
                                      :data="dueEmployeeEmails"
                                      no-data-template="Aucune donnée disponible"
                                      class="table table-striped table-bordered"
                            >
                                <div slot="email" slot-scope="props">
                                    {{ props.rowData.email }}
                                </div>
                                <div slot="status" slot-scope="props">
                                    <make-effective-email-status-slot :status="props.rowData.status"/>
                                </div>
                                <div slot="createdAt" slot-scope="props">
                                    {{ props.rowData.createdAt | formatDateToDisplay }}
                                </div>
                                <div slot="deliveredAt" slot-scope="props">
                                    {{ props.rowData.deliveredAt | formatDateToDisplay }}
                                </div>
                            </vuetable>

                            <Paginator :items.sync="dueEmployeeEmails"
                                       :pagination.sync="pagination"
                                       class="float-right"
                            ></Paginator>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Sidebar from '../../../components/Sidebar';
    import Footer from '../../../components/Footer';
    import FormError from '../../../components/FormError';
    import ValidationDelayTouch from '../../../mixins/validationDelayTouch';
    import ButtonSpinner from '../../../components/ButtonSpinner';
    import PageSpinner from '../../../components/PageSpinner';
    import Header from '../../../components/Header';
    import Vuetable from 'vuetable-2';
    import dueEmployeeEmailTableFields from "@/views/due/create/dueEmployeeEmailTableFields";
    import Paginator from '../../../components/Paginator';
    import ConfirmationModal from '@/components/modal/ConfirmationModal';
    import MakeEffectiveEmailStatusSlot from '@/components/table/due/MakeEffectiveEmailStatusSlot';
    import { email, required } from 'vuelidate/lib/validators';
    import { mapActions, mapGetters } from 'vuex';
    import {
        createDueSignOffSheetDocument, deleteDueSignOffSheetDocument, fetchDueById,
        fetchDueSignOffSheetDocument,
        fetchEmployeeEmails, makeDueEffective, sendDueEmployeeEmails, updateDueSignOffSheetDocument
    } from "@/service/api/dues.api";
    import { decodeDocument, downloadFile, fileToBase64, formatDateToDisplay } from "@/utils/utils";
    import { generateXlsxEmailTemplate, getEmailsFromXlsxFile } from "@/service/manager/xlsxManager";
    import { fileMineTypeConstraint, filesizeConstraint } from "@/utils/validation";
    import { errorMessage, messageTexts, successMessage } from "@/utils/sweet-alert-options";

    export default {
        mixins: [ValidationDelayTouch],
        data() {
            return {
                singleEmailFormData: {
                    email: '',
                    isSubmitting: false,
                },
                xlsxEmailsFormData: {
                    file: null,
                    emails: [],
                    isSubmitting: false,
                    isEnabled: false,
                },
                dueSignOffSheetDocumentFormData: {
                    file: null,
                    id: null
                },
                makeEffectiveFormData: {
                    isSubmitting: false,
                    isEnabled: true
                },
                modal: {
                    isShowModal: false
                },
                due: null,
                isLoading: true,
                fields: dueEmployeeEmailTableFields,
                dueEmployeeEmails: [],
                pagination: {
                    currentPage: 1,
                    totalItems: null,
                    itemsPerPage: 20
                },
                isActive: false,
            };
        },
        computed: {
            ...mapGetters({
                legalInformation: 'legalInformation',
            }),
            dueId() {
                return this.$route.params.id;
            },
            page() {
                return this.pagination.currentPage;
            },
            isNotEffective() {
                if (!this.due) {
                    return false;
                }

                return this.due.status !== 'effective';
            },
            isShowSpinner() {
                return this.isLoading || this.xlsxEmailsFormData.isSubmitting;
            },
            modalQuestion() {
                if (!this.due || !this.legalInformation) {
                    return;
                }

                const frameBeneficiaryCodes = ['b2', 'b3'];

                return frameBeneficiaryCodes.includes(this.due.beneficiary.code)
                    ? this.transformDueMakeEffectiveFrameLegalAdviceText
                    : this.legalInformation.dueMakeEffectiveLegalAdviceText.legalAdvice.join(' </br>')
                ;
            },
            transformDueMakeEffectiveFrameLegalAdviceText() {
                const prepareArr = this.legalInformation.dueMakeEffectiveFrameLegalAdviceText.legalAdvice.map((row, index) => {
                    return [1,3].includes(index) ? `${row} </br>` : row;
                });

                return prepareArr.join(' </br>');
            },
            dueMakeEffectivePageDescriptionLegalAdviceText() {
                return this.legalInformation.dueMakeEffectivePageDescriptionLegalAdviceText.legalAdvice.join(' </br>');
            },
            dueMakeEffectivePageContentListItemsLegalAdviceText() {
                return this.legalInformation.dueMakeEffectivePageContentListItemsLegalAdviceText.legalAdvice.join(' </br>');
            }
        },
        async created() {
            await this.fetchDueSignOffSheetDocument();
            await this.fetchDueLegalInformation();
            await this.fetchPaginatedEmployeeEmails();
            await this.fetchDue();
            this.isLoading = false;
        },
        methods: {
            ...mapActions({
                fetchDueLegalInformation: 'fetchDueLegalInformation'
            }),
            async fetchPaginatedEmployeeEmails() {
                const { data } = await fetchEmployeeEmails(this.pagination, this.dueId);
                this.dueEmployeeEmails = data.items;
                this.pagination.totalItems = data.totalItems;
                this.$refs.vuetable.setData(this.dueEmployeeEmails);
            },
            async fetchDueSignOffSheetDocument() {
                const { data } = await fetchDueSignOffSheetDocument(this.dueId);

                if (!data) {
                    return;
                }

                const decodedFile = await decodeDocument({
                    typeCode: 'DSOSD',
                    content: data.content
                });
                this.dueSignOffSheetDocumentFormData.file = decodedFile.content;
                this.dueSignOffSheetDocumentFormData.id = data.id;
            },
            async fetchDue() {
              const { data } = await fetchDueById(this.dueId);

              this.due = data;
            },
            async sendSingleEmail() {
                this.singleEmailFormData.isSubmitting = true;

                try {
                    await sendDueEmployeeEmails({
                        dueId: Number.parseInt(this.dueId),
                        emails: [this.singleEmailFormData.email]
                    });

                    this.singleEmailFormData.email = '';
                    this.$v.singleEmailFormData.email.$reset();
                    this.singleEmailFormData.isSubmitting = false;

                    this.$swal({ title: messageTexts.sendEmployeeSendEmailsSuccess, ...successMessage });

                    await this.fetchPaginatedEmployeeEmails();
                } catch ({ response }) {
                    this.singleEmailFormData.isSubmitting = true;
                }
            },
            async generateTemplate() {
                await generateXlsxEmailTemplate();
            },
            async handleXlsxFileUpload(event) {
                this.xlsxEmailsFormData.emails = [];
                this.makeEffectiveFormData.isEnabled = true;
                const file = event.target.files[0];

                if (!file) {
                    return;
                }

                this.xlsxEmailsFormData.file = file;
                const isValid = fileMineTypeConstraint(['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'])(file);

                if (isValid) {
                    this.xlsxEmailsFormData.emails = await getEmailsFromXlsxFile(file);

                    if (this.xlsxEmailsFormData.emails.length > 0) {
                        this.xlsxEmailsFormData.isEnabled = true;
                    }
                }
            },
            deleteXlsxFile() {
                this.xlsxEmailsFormData.file = null;
                this.xlsxEmailsFormData.isEnabled = false;
                this.xlsxEmailsFormData.emails = [];
                this.makeEffectiveFormData.isEnabled = true;
            },
            async sendXlsxEmails() {
                this.xlsxEmailsFormData.isSubmitting = true;

                try {
                    await sendDueEmployeeEmails({
                        dueId: Number.parseInt(this.dueId),
                        emails: this.xlsxEmailsFormData.emails
                    });

                    this.xlsxEmailsFormData.emails = [];
                    this.xlsxEmailsFormData.file = null;
                    this.xlsxEmailsFormData.isEnabled = false;
                    this.makeEffectiveFormData.isEnabled = true;
                    this.xlsxEmailsFormData.isSubmitting = false;

                    this.$swal({ title: messageTexts.sendEmployeeSendEmailsSuccess, ...successMessage });
                    await this.fetchPaginatedEmployeeEmails();
                } catch ({ response }) {
                    this.singleEmailFormData.isSubmitting = true;
                }
            },
            async deleteDocument() {
                this.dueSignOffSheetDocumentFormData.file = null;

                if (this.dueSignOffSheetDocumentFormData.id) {
                    await deleteDueSignOffSheetDocument(this.dueId, this.dueSignOffSheetDocumentFormData.id);
                    this.dueSignOffSheetDocumentFormData.id = null;
                }
            },
            async uploadDueSignOffSheetDocument(event) {
                this.dueSignOffSheetDocumentFormData.file = event.target.files[0];
                const isValid = filesizeConstraint(4000000)
                    && fileMineTypeConstraint(['image/jpeg', 'image/png', 'application/pdf'])(this.dueSignOffSheetDocumentFormData.file);

                if (!isValid) {
                    return;
                }

                try {
                    const content = await fileToBase64(this.dueSignOffSheetDocumentFormData.file);

                    if (this.dueSignOffSheetDocumentFormData.id) {
                        await updateDueSignOffSheetDocument(this.dueId, this.dueSignOffSheetDocumentFormData.id, { content });
                    } else {
                        const { data } = await createDueSignOffSheetDocument(this.dueId, { content });

                        this.dueSignOffSheetDocumentFormData.id = data.id;
                    }
                    this.$swal({ title: messageTexts.uploadDueSignOffSheetDocumentSuccess, ...successMessage });
                } catch (error) {
                    console.error(error);
                }
            },
            async downloadDocument() {
                await downloadFile({
                    content: this.dueSignOffSheetDocumentFormData.file
                });
            },
            handleOpenPopup() {
                if (this.xlsxEmailsFormData.emails.length > 0) {
                    this.makeEffectiveFormData.isEnabled = false;
                }

                if (!this.makeEffectiveFormData.isEnabled) {
                    return;
                }

                window.scrollTo({ top: 0, left: 0, behaviour: 'smooth' });
                this.modal.isShowModal = true;
            },
            async makeEffective() {
                this.makeEffectiveFormData.isSubmitting = true;

                try {
                    await makeDueEffective(this.dueId);
                    await this.$router.push({ name: 'due-list' })
                } catch (e) {
                    this.makeEffectiveFormData.isSubmitting = false;
                    this.$swal({ title: messageTexts.notAllBeneficiariesCovered, ...errorMessage });
                }
            },
        },
        validations: {
            singleEmailFormData: {
                email: {
                    email,
                    required
                },
            },
            xlsxEmailsFormData: {
                file: {
                    validMimeType: fileMineTypeConstraint(['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'])
                }
            },
            dueSignOffSheetDocumentFormData: {
                file: {
                    validFileSize: filesizeConstraint(4000000),
                    validMimeType: fileMineTypeConstraint(['image/jpeg', 'image/png', 'application/pdf'])
                }
            },
        },
        filters: {
            formatDateToDisplay
        },
        watch: {
            page() {
                this.fetchPaginatedEmployeeEmails();
            }
        },
        components: {
            Sidebar,
            Footer,
            FormError,
            ButtonSpinner,
            Header,
            Vuetable,
            Paginator,
            ConfirmationModal,
            PageSpinner,
            MakeEffectiveEmailStatusSlot
        }
    }
</script>
